import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useStoreApi } from '@xyflow/react';
import { isEnergyPort } from '../../../utils';
import { E_FLOW_HEX, M_FLOW_HEX } from '../../../constants';
/**
 * Component renders when user tries to connect two ReactFlow nodes
 * @param props : props come from ReactFlow.
 */
const RFConnectionFC = ({ fromX, fromY, toX, toY }) => {
    const { getState } = useStoreApi();
    const { fromHandle } = getState().connection;
    const isEdgeEnergy = isEnergyPort(fromHandle?.id);
    const color = isEdgeEnergy ? E_FLOW_HEX : M_FLOW_HEX;
    return (_jsxs("g", { children: [_jsx("path", { fill: "none", stroke: color, strokeWidth: 2, d: `M${fromX},${fromY} ${fromX} ${toY} ${fromX} ${toY} ${toX},${toY}` }), _jsx("circle", { cx: toX, cy: toY, fill: "#fff", r: 3, stroke: color, strokeWidth: 1.5 })] }));
};
export const RFConnection = RFConnectionFC;
//# sourceMappingURL=RFConnection.js.map